// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  remove_console_log: true,
  remove_console_warning: true,
  remove_console_error: true,
};

export const AppSettings = {
  // prefix: 'GC',
  // baseURL: 'http://localhost/lampapi-v2/faculty/',
  // downloadURL: 'http://localhost/lampapi-v2/',
  // booksURL: 'http://localhost/LAMP/documents/books/',
  // imageURL: 'http://localhost/requests/',
  // iflURL: 'http://localhost/Printables/',
  // appversion: require('../../package.json').version,
  // mainString: 'AvengersRockzWithZontheRocks',
  // hercules: "FVybLkThLMLNdx72dUwF",
  // athena: "ZdzChPsDFd9tUSP61867",
  // forgetme: "AES-256-CBC",
  // announcement: 'https://gordoncollegeccs.edu.ph/announcements/'

  prefix: 'GC',
  baseURL: 'https://gordoncollegeccs.edu.ph/lampapi-v2/faculty/',
  downloadURL: 'https://gordoncollegeccs.edu.ph/lampapi-v2/',
  booksURL: "https://gordoncollegeccs.edu.ph/downloads/books/",
  imageURL: 'https://gordoncollegeccs.edu.ph/requests/',
  iflURL: 'https://gordoncollegeccs.edu.ph/printables-v2/',
  appversion: require('../../package.json').version,
  mainString: 'AvengersRockzWithZontheRocks',
  hercules: "FVybLkThLMLNdx72dUwF",
  athena: "ZdzChPsDFd9tUSP61867",
  forgetme: "AES-256-CBC",
  announcement: 'https://gordoncollegeccs.edu.ph/announcements/'
}


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
